import EditorNoticia from '../components/EditorNoticia'

const EdicionNoticias = () => {
  return <EditorNoticia />
}

export default EdicionNoticias
